import React, { Component } from 'react';
import Events from '../../common/events';
import LambdaUtil from '../../aws/lambda/lambdaUtil';
import Globals from '../../common/globals';
import { strings } from '../../../localization';

export default class SupportPage extends Component {

    componentDidMount() {
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.app_sign_in_support) } }));

        if (window.AWS.config.credentials) {
            /* parse the search to grab the return_to */
            let returnto = this.props.returnto;

            if (!returnto) {
                returnto = "";
            }

            /* User logged in and is valid, do the SSO thing */
            LambdaUtil.getSupportURL(this.props.user.stage, returnto, this.onSupportURLSuccess, this.onSupportURLFail);
        }
        else {
            /* User not loggded in, go straight to support URL */

            window.location.href = Globals.supportUrl;
        }
    }

    onSupportURLSuccess = (data) => {
        var payload = JSON.parse(data.Payload);
        if (payload.status === "SUCCESS") {
            /* Redirect to the URL provided */
            window.location.href = payload.ssoUrl;
        }
        else {
            // Failed
            return this.onSupportURLFail(data);
        }
    }

    onSupportURLFail = (data) => {
        window.location.href = this.props.returnto;
    }

    render() {

        return null;
    }
}
